import { PublicClientApplication, type Configuration } from '@azure/msal-browser'

import { env } from '@/config/env'

/**
 * `null` whenever auth is switched off (`VITE_REQUIRE_AUTH=false`, the local
 * dev default) — local dev never has real Entra values to construct this
 * with, and nothing in the app should try to. Every caller checks for `null`
 * the same way route guards already check `env.requireAuth`.
 */
export const msalInstance: PublicClientApplication | null = env.requireAuth
  ? new PublicClientApplication({
      auth: {
        clientId: env.entraClientId,
        authority: `https://login.microsoftonline.com/${env.entraTenantId}`,
        // One redirect URI covers dev/staging/prod — each just needs to be
        // added as an allowed SPA redirect URI on the app registration itself.
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
      },
      cache: {
        // Session-scoped, not persisted across tabs/restarts — MSAL's own
        // security-preferred default over localStorage.
        cacheLocation: 'sessionStorage',
      },
    } satisfies Configuration)
  : null

/** Requested on interactive sign-in — identity only, no API access yet. */
export const loginRequest = { scopes: ['openid', 'profile', 'email'] }

/** Requested silently for every API call, once signed in. */
export const apiTokenRequest = { scopes: [env.entraApiScope] }
